<template>
    <div class="row">
        <div class="col-md-10 col-md-offset-1">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 p-l-0">
                    <h2>
                        {{
                            $t('dynamicess.headerAccountDetailsTempo', {
                                i18nFallback: 'EDF - Tempo Account Details',
                            })
                        }}
                    </h2>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 p-l-0">
                    <p>
                        {{
                            $t('dynamicess.edfTempo.intro', {
                                i18nFallback:
                                    'With a Tempo contract, prices rely on the state of the grid. A color is associated with it (Blue, White, Red). You can overwrite prices, if you think they are outdated.',
                            })
                        }}
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6 p-l-0">
                    <vrm-number-field
                        :model="tempoOverwriteBlueDayHours"
                        :title="
                            $t('dynamicess.edfTempo.blueDayTitle', {
                                i18nFallback: 'Blue day hours price',
                            })
                        "
                        :required="false"
                        :checks="[NOT_NEGATIVE_NUMBER]"
                        :data-indicator="$t('dynamicess.euro', { i18nFallback: '€' })"
                        @input="changeTempoOverwriteBlueDayHours"
                    />
                </div>
                <div class="col-xs-12 col-sm-6 p-l-0">
                    <vrm-number-field
                        :model="tempoOverwriteBlueNightHours"
                        :title="
                            $t('dynamicess.edfTempo.blueNightTitle', {
                                i18nFallback: 'Blue night hours price',
                            })
                        "
                        :required="false"
                        :checks="[NOT_NEGATIVE_NUMBER]"
                        :data-indicator="$t('dynamicess.euro', { i18nFallback: '€' })"
                        @input="changeTempoOverwriteBlueNightHours"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6 p-l-0">
                    <vrm-number-field
                        :model="tempoOverwriteWhiteDayHours"
                        :title="
                            $t('dynamicess.edfTempo.whiteDayTitle', {
                                i18nFallback: 'White day hours price',
                            })
                        "
                        :required="false"
                        :checks="[NOT_NEGATIVE_NUMBER]"
                        :data-indicator="$t('dynamicess.euro', { i18nFallback: '€' })"
                        @input="changeTempoOverwriteWhiteDayHours"
                    />
                </div>
                <div class="col-xs-12 col-sm-6 p-l-0">
                    <vrm-number-field
                        :model="tempoOverwriteWhiteNightHours"
                        :title="
                            $t('dynamicess.edfTempo.whiteNightTitle', {
                                i18nFallback: 'White night hours price',
                            })
                        "
                        :required="false"
                        :checks="[NOT_NEGATIVE_NUMBER]"
                        :data-indicator="$t('dynamicess.euro', { i18nFallback: '€' })"
                        @input="changeTempoOverwriteWhiteNightHours"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6 p-l-0">
                    <vrm-number-field
                        :model="tempoOverwriteRedDayHours"
                        :title="
                            $t('dynamicess.edfTempo.redDayTitle', {
                                i18nFallback: 'Red day hours price',
                            })
                        "
                        :required="false"
                        :checks="[NOT_NEGATIVE_NUMBER]"
                        :data-indicator="$t('dynamicess.euro', { i18nFallback: '€' })"
                        @input="changeTempoOverwriteRedDayHours"
                    />
                </div>
                <div class="col-xs-12 col-sm-6 p-l-0">
                    <vrm-number-field
                        :model="tempoOverwriteRedNightHours"
                        :title="
                            $t('dynamicess.edfTempo.redNightTitle', {
                                i18nFallback: 'Red night hours price',
                            })
                        "
                        :required="false"
                        :checks="[NOT_NEGATIVE_NUMBER]"
                        :data-indicator="$t('dynamicess.euro', { i18nFallback: '€' })"
                        @input="changeTempoOverwriteRedNightHours"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmNumberField from '@/vue/components/forms/VrmNumberField.vue';
import { NOT_NEGATIVE_NUMBER } from '@/vue/constants/validation-checks';

@Component({
    components: {
        VrmNumberField,
    },
})
export default class EdfTempoForm extends Vue {
    NOT_NEGATIVE_NUMBER = NOT_NEGATIVE_NUMBER;

    @Prop() tempoOverwriteBlueDayHours;
    @Prop() tempoOverwriteBlueNightHours;
    @Prop() tempoOverwriteRedDayHours;
    @Prop() tempoOverwriteRedNightHours;
    @Prop() tempoOverwriteWhiteDayHours;
    @Prop() tempoOverwriteWhiteNightHours;

    changeTempoOverwriteBlueDayHours(value) {
        this.$emit('on-change-tempo-overwrite-blue-day-hours', value);
    }

    changeTempoOverwriteBlueNightHours(value) {
        this.$emit('on-change-tempo-overwrite-blue-night-hours', value);
    }

    changeTempoOverwriteRedDayHours(value) {
        this.$emit('on-change-tempo-overwrite-red-day-hours', value);
    }

    changeTempoOverwriteRedNightHours(value) {
        this.$emit('on-change-tempo-overwrite-red-night-hours', value);
    }

    changeTempoOverwriteWhiteDayHours(value) {
        this.$emit('on-change-tempo-overwrite-white-day-hours', value);
    }

    changeTempoOverwriteWhiteNightHours(value) {
        this.$emit('on-change-tempo-overwrite-white-night-hours', value);
    }
}
</script>
